import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";
import Input from "../2/Controls/Input";
import AddTransaction from "./AddTransaction";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";

class AccountManagementList extends Component {

  constructor(props) {
    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      showDelete: false,
      showAddTransaction: false,
      showFilter: false,
      showOption: false,

      selectedRow: null,

      cancellationReason: "",
      cancellationReasonError: "",

      filters: {
        fromDate: "",
        toDate: "",
        paymentType: "",
        fromAccount: "",
        toAccount: ""
      },

      cashRegisters: [],
      accountList: [],

      listPageSettings: {

        Title: "Account Management",

        Search: { showSearch: false },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
          {
            ButtonType: "ImageButton",
            Type: "filter",
            Icon: "filter",
            Action: "filter"
          },
          {
            ButtonType: "ImageButton",
            Type: "option",
            Icon: "option",
            Action: "options"
          }
        ],

        Columns: [

          {
            Name: "Date",
            Type: "multiple",
            Columns: [
              { Column: "TransactionDate", Type: "date" },
              { Column: "CancellationReason", Type: "badge", CSS: "red" }
            ]
          },

          {
            Name: "From Account",
            Type: "field",
            Columns: [{ Column: "FromAccount" }]
          },

          {
            Name: "To Account",
            Type: "field",
            Columns: [{ Column: "ToAccount" }]
          },

          {
            Name: "Payment Mode",
            Type: "field",
            Columns: [{ Column: "PaymentType" }]
          },

          {
            Name: "Amount",
            Type: "field",
            Columns: [{ Column: "Amount", Type: "number" }]
          },

          {
            Name: "Remark",
            Type: "field",
            Columns: [{ Column: "PaymentRemark" }]
          },

          {
            Name: "Date",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "TransactionDate", Type: "date" },
              { Column: "CancellationReason", Type: "badge", CSS: "red" },
              { Column: "FromAccount", Label: "From" },
              { Column: "ToAccount", Label: "To" },
              { Column: "PaymentType" },
              { Column: "Amount", Label: "Amount" }
            ]
          }

        ],

        RowButtons: [
          {
            ButtonType: "ImageButton",
            Type: "delete",
            Icon: "delete",
            condition: (row) =>
        !row.hasOwnProperty("CancellationReason") ||
    row.CancellationReason === ""
          }
        ]

      }

    };
  }

  componentDidMount() {

    this.loadCashRegister(this.props.user.store.key);
    this.loadAccounts();

    this.loadData();

  }

  componentDidUpdate(prevProps, prevState) {

    if (
      prevState.page !== this.state.page ||
      prevState.pageSize !== this.state.pageSize
    ) {

      this.loadData();

    }

  }

  // ======================
  // LOAD DATA
  // ======================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const from = (this.state.page - 1) * this.state.pageSize;
      const size = this.state.pageSize;

      const f = this.state.filters;

      let response = await this.props.getTransactions(
          from,
  size,
    this.props.user.store.key,
    f.fromDate,
        f.toDate,
  f.paymentType,
        f.toAccount,
        f.fromAccount

      );

      this.setState({

        list: response.searchResult || [],
        totalCount: response.totalItemsCount || 0,
        loading: false

      });

    }
    catch (error) {

      console.log(error);

      this.setState({ loading: false });

    }

  };


  // ======================
  // PAGINATION
  // ======================

  onNextClick = () => {

    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);

    if (this.state.page < totalPages)
      this.setState({ page: this.state.page + 1 });

  };

  onPreviousClick = () => {

    if (this.state.page > 1)
      this.setState({ page: this.state.page - 1 });

  };

  onFirstClick = () => this.setState({ page: 1 });

  onLastClick = () => {

    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);

    this.setState({ page: totalPages });

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({
      pageSize: Number(size),
      page: 1
    });

  };


  // ======================
  // HEADER BUTTONS
  // ======================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new")
      this.setState({
        showAddTransaction: true,
        selectedRow: null
      });

    if (btn.Action === "filter")
      this.setState({ showFilter: true });

    if (btn.Action === "options")
      this.setState({ showOption: true });

  };


  // ======================
  // FILTER
  // ======================

  onFilterChange = (field, value) => {

    this.setState({

      filters: {
        ...this.state.filters,
        [field]: value
      }

    });

  };

  onApplyFilter = () => {

    this.setState(
      {
        showFilter: false,
        page: 1
      },
      this.loadData
    );

  };

  onClearFilter = () => {

    this.setState(
      {
        filters: {
          fromDate: "",
          toDate: "",
          paymentType: "",
          fromAccount: "",
          toAccount: ""
        },
        showFilter: false,
        page: 1
      },
      this.loadData
    );

  };


  // ======================
  // DELETE
  // ======================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row,
        cancellationReason: "",
        cancellationReasonError: ""
      });

    }

  };

  deleteRecord = async () => {

    if (!this.state.cancellationReason) {

      this.setState({
        cancellationReasonError: "Cancellation reason required"
      });

      return;

    }



    this.setState({showDelete: false, loading: true });

    await this.props.cancelTransaction(

      this.state.cancellationReason,
      this.state.selectedRow.key

    );

      await new Promise(resolve => setTimeout(resolve, 3000));

    this.setState({

      loading: false,
      selectedRow: null

    });

    this.loadData();

  };


  // ======================
  // EXPORT
  // ======================

  
  getExportData = async () => {

    const f = this.state.filters;

    this.setState({ loading: true });

    let response = await this.props.getTransactions(
      0,
      10000,
    this.props.user.store.key,
    f.fromDate,
        f.toDate,
  f.paymentType,
        f.toAccount,
        f.fromAccount
    );

    this.setState({ loading: false });

    return  response.searchResult || []
  };


  
    handleExport = async (type) => {
    this.setState({ loading: true });
      try {
  
        const data =
          await this.getExportData();
  
        if (!data.length) {
  
          alert("No data found");
  
          return;
  
        }
  
   
  
 const columns = [

      { header: "TransactionDate", field: "TransactionDate", type: "date" },
      { header: "From Account", field: "FromAccount" },
      { header: "To Account", field: "ToAccount" },
      { header: "Payment Type", field: "PaymentType" },
      { header: "Amount", field: "Amount" },
      { header: "Remark", field: "PaymentRemark" },
      { header: "Cancellation Reason", field: "CancellationReason" }

    ];
  
        await exportFile({
  
          data: data,
  
          columns: columns,
  
          fileType: type,
  
          title: "AccountManagement",
  
          landscape: true
  
        });
  
      }
  
      catch (error) {
  this.setState({ loading: false });
        console.error(error);
  
        alert("Export failed");
  
      }
      finally{
            this.setState({ loading: false });
      }
  
    };
  // ======================
  // LOAD DROPDOWNS
  // ======================

  async loadCashRegister(storeID) {

    let data = await this.props.getCashRegisters(storeID);

    this.setState({ cashRegisters: data || [] });

  }

  async loadAccounts() {

    let accounts = await this.props.getAccounts(

      this.props.user.user.RegistrationID

    );

    let finalAccounts = [];

    accounts.forEach(a => {

      if (!a.IsDeleted) {

        if (a.AllStores)
          finalAccounts.push(a);

        else {

          a.Stores.forEach(s => {

            if (s.value === this.props.user.store.key)
              finalAccounts.push(a);

          });

        }

      }

    });

    this.setState({ accountList: finalAccounts });

  }


  // ======================
  // POPUP
  // ======================

  onPostPopupSave = () => {

    this.setState(
      { showAddTransaction: false },
      this.loadData
    );

  };

  onClosePopup = () =>
    this.setState({ showAddTransaction: false });



  // ======================
  // RENDER
  // ======================

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    const f = this.state.filters;

    return (

      <>

        <ListingPage

          {...this.props}
           onPageChange={this.onPageChange}

          listPageSettings={this.state.listPageSettings}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />


        {/* DELETE */}

        {this.state.showDelete && (

          <Window

            header="Cancellation Reason"

            modal

            onClose={() =>
              this.setState({ showDelete: false })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();

              else
                this.setState({ showDelete: false });

            }}

            buttons={[

              { Type: "secondary", Text: "No", Align: "left" },

              { Type: "primary", Text: "Yes", Align: "right" }

            ]}

              

          >

            <Input

              type="textarea"

              label="Enter Reason"

              value={this.state.cancellationReason}

              error={this.state.cancellationReasonError}

              onChange={(v) =>
                this.setState({
                  cancellationReason: v,
                  cancellationReasonError: ""
                })
              }

            />

          </Window>

        )}


        {/* ADD */}

        {this.state.showAddTransaction && (

          <AddTransaction

            {...this.props}

            transaction={this.state.selectedRow}

            onSave={this.onPostPopupSave}

            onClose={this.onClosePopup}

          />

        )}


        {/* FILTER */}

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() =>
              this.setState({ showFilter: false })
            }

            onButtonClick={(action) => {

              if (action === "Apply")
                this.onApplyFilter();

              if (action === "Clear")
                this.onClearFilter();

            }}

            buttons={[

              { Type: "secondary", Text: "Clear",Align:"left" },

              { Type: "primary", Text: "Apply",Align:"right" }

            ]}

          >

            <Input
              type="date"
              label="From Date"
              value={f.fromDate}
              onChange={(v) => this.onFilterChange("fromDate", v)}
            />

            <Input
              type="date"
              label="To Date"
              value={f.toDate}
              onChange={(v) => this.onFilterChange("toDate", v)}
            />

            <Input
              type="select"
              label="Payment Mode"
              value={f.paymentType}
              onChange={(v) => this.onFilterChange("paymentType", v)}
            >

              <option value="">All</option>

              {this.props.config.PaymentTypes
                .filter(x => !x.IsDeleted)
                .map(x =>
                  <option value={x.key}>{x.PaymentType}</option>
                )}

            </Input>


            <Input
              type="select"
              label="From Account"
              value={f.fromAccount}
              onChange={(v) => this.onFilterChange("fromAccount", v)}
            >

              <option value="">All</option>

              <optgroup label="Cash Register">

                {this.state.cashRegisters.map(x =>
                  <option value={x.key}>
                    {x.CashRegisterCode}-{x.CashRegisterName}
                  </option>
                )}

              </optgroup>

              <optgroup label="Account">

                {this.state.accountList.map(x =>
                  <option value={x.key}>{x.Name}</option>
                )}

              </optgroup>

            </Input>


            <Input
              type="select"
              label="To Account"
              value={f.toAccount}
              onChange={(v) => this.onFilterChange("toAccount", v)}
            >

              <option value="">All</option>

              <optgroup label="Cash Register">

                {this.state.cashRegisters.map(x =>
                  <option value={x.key}>
                    {x.CashRegisterCode}-{x.CashRegisterName}
                  </option>
                )}

              </optgroup>

              <optgroup label="Account">

                {this.state.accountList.map(x =>
                  <option value={x.key}>{x.Name}</option>
                )}

              </optgroup>

            </Input>

          </Window>

        )}


        {/* OPTIONS */}

        {this.state.showOption && (

          <Window

            header="Options" choiceList

            size="small"

            slide

            onClose={() =>
              this.setState({ showOption: false })
            }

          >

            <ExportButton

              onExport={this.handleExport}

              loading={this.state.loading}

            />

          </Window>

        )}

      </>

    );

  }

}

export default AccountManagementList;